<template>
	<button
		@click.prevent=""
		class="flex items-center text-slate-500 hover:text-slate-800 bg-slate-50 border border-slate-800 rounded-md py-2 px-5 hover:shadow-md w-full lg:w-auto justify-center"
		:class="{
			'pointer-events-none cursor-not-allowed': loading,
		}">
		<div v-if="!loading" class="flex">
			<p v-if="$slots.icon" :class="{ 'mr-3': $slots.text }">
				<slot name="icon"></slot>
			</p>
			<p class="font-medium whitespace-nowrap" v-if="$slots.text">
				<slot name="text"></slot>
			</p>
		</div>
		<p class="font-medium px-10" v-else>
			<i class="fas fa-circle-notch fa-spin"></i>
		</p>
	</button>
</template>

<script setup>
	const props = defineProps({
		loading: {
			type: [String, Boolean],
			default: false,
		},
		position: {
			type: String,
			default: 'left',
		},
		isSubmit: {
			type: Boolean,
			default: true,
		},
	});
</script>
